/**
 * Created by saeed on 12/12/2016.
 */

angular.module('tikonApp').directive('eoRequired', ['AlertService', '$timeout', function (alertService, $timeout) {

    return {

        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {

            if (attrs.eoRequired == 'false') return;
            $timeout(function () {

                var vm = this;
                //validation message to show
                var message = 'messages.common.eoRequired';


                //validator function
                ctrl.$validators.eoRequired = function (modelValue, viewValue) {

                    if (modelValue)
                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty models to be valid
                            alertService.showValidationMessage(elm, message);
                            return false;
                        } else {

                            return true;
                        }

                };
            });


        }
    };
}]);
